import { jsx as o } from "react/jsx-runtime";
const r = ({ size: t, className: e }) => /* @__PURE__ */ o(
  "svg",
  {
    className: e,
    fill: "none",
    height: t,
    viewBox: "0 0 20 20",
    width: t,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o("g", { id: "electric-icons", children: /* @__PURE__ */ o(
      "path",
      {
        d: "M8.67333 18L15.2857 8.54563H10.8775L11.6124 2L5 11.455H9.40826L8.67333 18Z",
        id: "Vector",
        stroke: "#333333",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "0.9"
      }
    ) })
  }
);
export {
  r as Electric
};
